/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdWebFeaturesStoreBank131PaymentFormDataResponseAddressFromJSON, FxIdWebFeaturesStoreBank131PaymentFormDataResponseAddressToJSON, } from './FxIdWebFeaturesStoreBank131PaymentFormDataResponseAddress';
import { FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormRedirectUrisFromJSON, FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormRedirectUrisToJSON, } from './FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormRedirectUris';
import { FxIdWebFeaturesStoreBank131PaymentFormDataResponseBank131PaymentFormResultCardInfoFromJSON, FxIdWebFeaturesStoreBank131PaymentFormDataResponseBank131PaymentFormResultCardInfoToJSON, } from './FxIdWebFeaturesStoreBank131PaymentFormDataResponseBank131PaymentFormResultCardInfo';
import { FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultProductInfoFromJSON, FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultProductInfoToJSON, } from './FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultProductInfo';
import { FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultBank131InfoFromJSON, FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultBank131InfoToJSON, } from './FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultBank131Info';
/**
 * Check if a given object implements the FxIdWebFeaturesStoreBank131PaymentFormDataResponse interface.
 */
export function instanceOfFxIdWebFeaturesStoreBank131PaymentFormDataResponse(value) {
    if (!('Bank131PaymentFormResultBank131Info' in value) || value['Bank131PaymentFormResultBank131Info'] === undefined)
        return false;
    if (!('Bank131PaymentFormResultProductInfo' in value) || value['Bank131PaymentFormResultProductInfo'] === undefined)
        return false;
    if (!('Bank131PaymentFormRedirectUris' in value) || value['Bank131PaymentFormRedirectUris'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreBank131PaymentFormDataResponseFromJSON(json) {
    return FxIdWebFeaturesStoreBank131PaymentFormDataResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreBank131PaymentFormDataResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Bank131PaymentFormResultBank131Info': FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultBank131InfoFromJSON(json['Bank131PaymentFormResultBank131Info']),
        'Bank131PaymentFormResultProductInfo': FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultProductInfoFromJSON(json['Bank131PaymentFormResultProductInfo']),
        'Bank131PaymentFormRedirectUris': FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormRedirectUrisFromJSON(json['Bank131PaymentFormRedirectUris']),
        'Address': json['Address'] == null ? undefined : FxIdWebFeaturesStoreBank131PaymentFormDataResponseAddressFromJSON(json['Address']),
        'Bank131PaymentFormResultCardInfo': json['Bank131PaymentFormResultCardInfo'] == null ? undefined : FxIdWebFeaturesStoreBank131PaymentFormDataResponseBank131PaymentFormResultCardInfoFromJSON(json['Bank131PaymentFormResultCardInfo']),
    };
}
export function FxIdWebFeaturesStoreBank131PaymentFormDataResponseToJSON(json) {
    return FxIdWebFeaturesStoreBank131PaymentFormDataResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreBank131PaymentFormDataResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Bank131PaymentFormResultBank131Info': FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultBank131InfoToJSON(value['Bank131PaymentFormResultBank131Info']),
        'Bank131PaymentFormResultProductInfo': FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormResultProductInfoToJSON(value['Bank131PaymentFormResultProductInfo']),
        'Bank131PaymentFormRedirectUris': FxIdWebFeaturesStoreBank131PaymentFormDataBank131PaymentFormRedirectUrisToJSON(value['Bank131PaymentFormRedirectUris']),
        'Address': FxIdWebFeaturesStoreBank131PaymentFormDataResponseAddressToJSON(value['Address']),
        'Bank131PaymentFormResultCardInfo': FxIdWebFeaturesStoreBank131PaymentFormDataResponseBank131PaymentFormResultCardInfoToJSON(value['Bank131PaymentFormResultCardInfo']),
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreBank131PaymentFormDataResponse.js.map